import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonContent,
  IonModal,
  IonTitle
} from '@ionic/react';
import SanatizedHtml from 'components/SanatizedHtml';
import classes from './style.module.scss';

const CustomModule = ({ isOpen, dismiss, title, content }) => {
  return (
    <IonModal isOpen={isOpen}>
      <IonHeader translucent>
        <IonToolbar>
          <IonTitle>{title}</IonTitle>
          <IonButtons slot='end'>
            <IonButton
              onClick={(e) => {
                e.stopPropagation();
                dismiss();
              }}
            >
              Close
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className={classes.modalContent}>
        <div>
          <SanatizedHtml dirtyHtml={content} />
        </div>
      </IonContent>
    </IonModal>
  );
};

export default CustomModule;
